import Vue from "vue";
import * as ENDPOINTS from "./endpoints";
import { resolveRequestError } from "@/utils/auth";

export default class PermissionService {

    // ============ Get Permissions =============
    static async getPermissions(){
        try{
            const { data } = await Vue.http.get(ENDPOINTS.PERMISSIONS);
            return data;
        }
        catch(error){
            resolveRequestError(error)
        }
    }

    // ============ FUNCTION TO GIVE ADMIN PERMISSIONS ==============
    static async addPermissions( { id, permissions }){
        try {
            const { data } = await Vue.http.patch(ENDPOINTS.PERMISSIONS, {
                id,
                permissions
            });
            return data;
        } catch (error) {
            resolveRequestError(error)
        }
    }

     // ============ FUNCTION TO GIVE DEPARTMENT PERMISSIONS ==============
     static async addDeptPermissions( { id, permissions }){
        try {
            const { data } = await Vue.http.put(ENDPOINTS.PERMISSIONS, {
                id,
                permissions
            });
            return data;
        } catch (error) {
            resolveRequestError(error)
        }
    }
}